export default class PlayersPointsFilters {
  public templateId: string = null;
}
